import { useTranslation } from '@lichtblick/i18next';

import { Container } from './EmptyTableWarning.styles';

import { ErrorMessage } from '../ErrorMessage';

type EmptyTableWarningProps = {
  reset: () => void;
};

export const EmptyTableWarning = ({ reset }: EmptyTableWarningProps) => {
  const { t } = useTranslation('errors');

  return (
    <Container>
      <ErrorMessage
        buttonLabel={t('errorButtonLabel')}
        description={t('emptyTableDescription')}
        onClick={reset}
        title={t('emptyTableTitle')}
      />
    </Container>
  );
};
